var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageToneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.836,
    height: 13,
    viewBox: "0 0 10.836 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_83752",
    "data-name": "Path 83752",
    d: "M13.251,6.042a.539.539,0,0,1,.332.5V18.457a.542.542,0,0,1-.921.386L9.492,15.73H7.625A1.625,1.625,0,0,1,6,14.105V10.866A1.623,1.623,0,0,1,7.625,9.241H9.492l3.17-3.087A.534.534,0,0,1,13.251,6.042ZM12.5,7.826l-2.409,2.344a.536.536,0,0,1-.379.155H7.625a.541.541,0,0,0-.542.542v3.239a.543.543,0,0,0,.542.542H9.712a.529.529,0,0,1,.379.155L12.5,17.164Zm2.286,1.629a.541.541,0,0,1,.762-.087h0v0l.007,0,.014.014a.469.469,0,0,1,.051.043c.04.036.094.087.155.152a3.7,3.7,0,0,1,.437.585,4.412,4.412,0,0,1,.621,2.329,4.408,4.408,0,0,1-.621,2.325,3.592,3.592,0,0,1-.437.589c-.061.065-.116.116-.155.152-.022.022-.043.04-.065.058l-.007.007h0s-.484.264-.758-.083a.539.539,0,0,1,.079-.758l0,0,0,0,0,0h0a.13.13,0,0,1,.018-.014c.022-.018.051-.051.094-.094a2.735,2.735,0,0,0,.307-.412,3.357,3.357,0,0,0,.462-1.766,3.347,3.347,0,0,0-.462-1.766,2.735,2.735,0,0,0-.307-.412.962.962,0,0,0-.094-.09.081.081,0,0,0-.018-.018h0A.54.54,0,0,1,14.785,9.454Zm.087.758h0Z",
    transform: "translate(-6 -5.998)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageToneIcon);
export default __webpack_public_path__ + "static/media/message-tone-icon.0d00976a4facea3faf65667d9672261e.svg";
export { ForwardRef as ReactComponent };